export const en = {
    female: 'Female',
    male: 'Male',
};
